import { Directive, HostListener, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[pplSelectedRadioFocus]',
    standalone: true
})
export class PPLRadioFocusDirective {
    constructor(private el: ElementRef) { }

    @HostListener('focusin', ['$event'])
    onFocusIn(event: FocusEvent) {
        this.setFocusOnRadioButtons();
    }

    setFocusOnRadioButtons() {
        const radios: NodeListOf<HTMLElement> = this.el.nativeElement.querySelectorAll('label');
        const selectedRadio = Array.from(radios).find(radio => {
            const input = radio.querySelector('input') as HTMLInputElement;
            return input?.checked;
        });

        radios.forEach(radio => {
            const input = radio.querySelector('input') as HTMLInputElement;
            input.tabIndex = -1; // Make all radios unfocusable
        });

        if (selectedRadio) {
            const input = selectedRadio.querySelector('input') as HTMLInputElement;
            this.el.nativeElement.setAttribute('aria-label', selectedRadio.textContent?.trim());
            input.tabIndex = 0;
            setTimeout(() => input.focus(), 200); // Focus the selected radio after view init
        } else if (radios.length > 0) {
            const input = radios[0].querySelector('input') as HTMLInputElement;
            input.tabIndex = 0;
            setTimeout(() => input.focus(), 50);
        }
    }
}
